module.exports = __webpack_public_path__ + "img/1146.2458fdac.gif";